<div id="assign-sheets">
    <div class="fullpage-sheet-viewer">
        <app-sheet-view [sheet]="sheet" [showExercices]="false" [showExamination]="false" [filterByStudent]=""
            *ngIf="sheet"></app-sheet-view>
        <i class="material-icons back-btn" routerLink="../../../../..">arrow_back</i>
    </div>
</div>